import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import metadata from './UnderwritingInformationComponent.metadata.json5';
import styles from '../../../pages/Accountant/AccountantPage.module.scss';

function UnderwritingInformationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('UnderwritingInformationComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true



    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifYesHowManTim3: {
            visible: !_.isUndefined(modelVM.value.areYouYouEmpOrAnyOf2) && modelVM.value.areYouYouEmpOrAnyOf2
        },
        pleProDet5: {
            visible: !_.isUndefined(modelVM.value.hadTheLicSusOrTerBy4) && modelVM.value.hadTheLicSusOrTerBy4
        },
        pleProDet7: {
            visible: !_.isUndefined(modelVM.value.eveBeeCalBefAnInvCom6) && modelVM.value.eveBeeCalBefAnInvCom6
        },
        pleProDet9: {
            visible: !_.isUndefined(modelVM.value.beeCenOrFinByAReg8) && modelVM.value.beeCenOrFinByAReg8
        },
        pleProDet11: {
            visible: !_.isUndefined(modelVM.value.eveBeeTheRecOfAnyAll10) && modelVM.value.eveBeeTheRecOfAnyAll10
        },
        pleProDet12: {
            visible: !_.isUndefined(modelVM.value.hasTheAppCom) && modelVM.value.hasTheAppCom
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

UnderwritingInformationComponent.propTypes = wizardProps;
export default withRouter(UnderwritingInformationComponent);
